import script from "./Receipts.vue?vue&type=script&setup=true&lang=js"
export * from "./Receipts.vue?vue&type=script&setup=true&lang=js"

import "./Receipts.vue?vue&type=style&index=0&id=066a9117&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-066a9117"]])

export default __exports__